import { SVGProps } from 'react'

export const Comment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <g clipPath="url(#clip0_116_11004)">
      <path
        fill="currentColor"
        d="M14.667 1.333H1.34l-.007 13.334L4 12h10.667V1.333zm-2.667 8H4V8h8v1.333zm0-2H4V6h8v1.333zm0-2H4V4h8v1.333z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_116_11004">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>
)
